export const VISIBILITY_OPTIONS = [
  { label: 'Privé', value: 0 },
  { label: 'Amis', value: 1 },
  { label: 'Public', value: 2 }
]
